<template>
	<div class="default">
		<Header />
		<div class="layout-content inner-menu-sticky" v-show="hasTabs || getFooter">
			<InnerMenu :isFooter="getFooter ? true : ''" />
		</div>
		<Cookie />
		<router-view
			class="layout-content"
			id="main-layout"
			:class="{ 'top-margin': hasTabs || getFooter }"
		/>
		<Footer />
	</div>
</template>

<script>
import Header from '@/components/modules/Header';
import InnerMenu from '@/components/InnerMenu';
import Footer from '@/components/modules/Footer';
import Cookie from '@/components/CookiePolicy';
import Main from '@/mixins/main';

export default {
	components: {
		Header,
		InnerMenu,
		Cookie,
		Footer,
	},
	mixins: [Main],

	computed: {
		getParentInfo() {
			const parentId = _.get(this.$store.state.main, 'selected_menu.pid');
			const menus = _.get(this.$store.state.main.indx, 'menus');
			const parent = menus.find((item) => item.id === parentId);

			const parentMenu = _.get(this.$store.state.main, 'selected_menu');

			return parent || parentMenu;
		},
		getFooter() {
			const selectedMenu = _.get(this.$store.state.main, 'selected_menu');
			const menus = _.get(this.$store.state.main.indx, 'menus');
			const footer = menus.filter((item) => item.menu_type === 'footer');
			const data = footer.filter((item) => item.id === selectedMenu.id);

			return data?.length ? true : false;
		},
		hasTabs() {
			console.log(
				this.getParentInfo,
				'getParentInfo',
				this.getParentInfo?.configs?.includes('has-tabs')
			);
			return this.getParentInfo?.configs?.includes('has-tabs');
		},
	},
};
</script>

<style lang="scss">
.default {
	overflow: hidden;
}
.layout-content {
	margin-left: 360px;
	@media (max-width: 1599px) {
		margin-left: 265px;
	}
	@media (max-width: 1439px) {
		margin-left: 251px;
	}
	@media (max-width: 1365px) {
		margin-left: 246px;
	}
	@media (max-width: 1023px) {
		margin-left: 241px;
	}
	@media (max-width: 767px) {
		margin-left: 0;
		margin-top: 264px;
	}
}
.top-margin {
	margin-top: 0;
	@media (max-width: 767px) {
		margin-top: 0;
	}
}
.inner-menu-sticky {
	position: sticky;
	top: -180px;
	z-index: 100;
	@media (max-width: 1365px) {
		position: sticky;
		top: -110px;
		z-index: 1;
	}
	@media (max-width: 1023px) {
		position: unset;
		top: 0px;
		z-index: 1;
	}
}
</style>
